import {isRedactedField} from '@/uptk/core/classification/redaction';
import {questionsValid,type CalcQuestion} from './calcModel';

/** A version denotes exactly one published document; duplicates never choose an arbitrary row. */
export function documentQuestions(rows:Record<string,unknown>[],source:{versionField:string;documentField:string;statusField:string;publishedValue:string;expectedQuestions:number},version:string):CalcQuestion[]{
 const fields=[source.versionField,source.documentField,source.statusField];
 if(rows.some(row=>fields.some(field=>isRedactedField(row,field))))return [];
 const matches=rows.filter(row=>row[source.versionField]===version&&row[source.statusField]===source.publishedValue);
 if(matches.length!==1)return [];
 try{const value=matches[0][source.documentField],questions=typeof value==='string'?JSON.parse(value):value;
  return Array.isArray(questions)&&questions.length===source.expectedQuestions&&questionsValid(questions)?questions:[];
 }catch{return [];}
}
